import { create } from 'zustand';

import { MarkerData } from '../../ClientDashboardV2';

interface FilterDrawerStore {
  isFilterDrawerOpen: boolean;
  markers: MarkerData[];
  appliedClientFilter: number[];
  activityFilter: boolean | null;
  toggleFilterDrawer: () => void;
  closeFilterDrawer: () => void;
  setMarkers: (markers: MarkerData[]) => void;
  setAppliedClientFilter: (ids: number[]) => void;
  setActivityFilter: (filter: boolean | null) => void;
}

export const useFilterDrawerStore = create<FilterDrawerStore>(set => ({
  isFilterDrawerOpen: false,
  markers: [],
  appliedClientFilter: [],
  activityFilter: null,
  toggleFilterDrawer: () => set(state => ({ isFilterDrawerOpen: !state.isFilterDrawerOpen })),
  closeFilterDrawer: () => set({ isFilterDrawerOpen: false }),
  setMarkers: markers => set({ markers }),
  setAppliedClientFilter: ids => set({ appliedClientFilter: ids }),
  setActivityFilter: filter => set({ activityFilter: filter }),
}));
